import '@scss/v1/layout_v1.scss';

import 'popper.js';
import 'bootstrap'
import './common/nav';
import 'smartmenus';
import 'smartmenus-bootstrap';

import './widget/content_show_more/content_show_more.js';
import './widget/fb_gallery/fb_gallery.js';
import './widget/instagram/instagram.js';
import './widget/newsletter/newsletter.js';
import './widget/recent_houses/recent_houses.js';
import './widget/information_request/information_request.js';
import './widget/cookie_alert/cookie_alert.js';
import './widget/newsletter_popups/popups.js';
import './widget/map/map_control.js';
import './widget/popupIE/popupIE.js';

import './common/custom';

import FavoritesManager from './common/favorites-manager/favorites-manager.js' ;
import CurrencyManager from './common/currency-manager/currency-manager.js' ;

// initialize counter icon
FavoritesManager.updateCounterIcon();
// initialize currency module
(function ($) {
    CurrencyManager.updateSelectionCurrency()
    $(document).on('click', '.currency-item-button', function (e) {
        e.preventDefault();
        e.stopPropagation();
        CurrencyManager.setUserCurrency($(this).data('currency'));
    });
})(jQuery);
